export function dataLayerPush(args = {}) {
  (window.dataLayer || []).push({
    ...args,
  });
}

export function dataLayerPushArgs(...args) {
  (window.dataLayer || []).push(...args);
}
